/**
 * This plugin is used to track pageviews on Google Analytics.
 */
import { GTM_PAGEVIEW_EVENT_NAME } from '@/constants/global';

export default function (ctx) {
  let isFirstLoad = true;

  ctx.app.router.beforeEach((_, __, next) => {
    if (isFirstLoad) {
      next();
      return;
    }

    next();
  });

  ctx.app.router.afterEach((to) => {
    /**
     * Do not track pageviews when nuxt loads the very first time to avoid
     * duplicated records on GA, this is happening because we're initializing
     * manually gtm on the base layout.
     *
     * TODO: We should remove this flag when all pages are already migrated to
     * Nuxt and if we use the autoinit gtm flag, also we should update the
     * `Pro - GA - Pageview` GTM tag that tracks the pageviews and use only the
     * `pageview` custom event for nuxt, then we should remove the generic GA
     * trigger (All Pages).
     *
     * TODO: Use runtimeconfig to setup gtm module.
     */
    if (isFirstLoad) {
      isFirstLoad = false;
      return;
    }

    const { $gtag, store } = ctx;
    const urlData = new URL(window.location.href);
    const pageUrl = urlData.pathname + urlData.search;
    const TIMEOUT_MS = 250;
    const pageviewParameters = {
      pageType: 'PageView',
      pageUrl,
      pageLocation: window.location.href,
      pagePath: pageUrl,
      routeName: to.name || '',
    };

    setTimeout(() => {
      $gtag('event', GTM_PAGEVIEW_EVENT_NAME, {
        pageType: 'PageView',
        pageTitle: document.title,
        ...pageviewParameters,
      });
    }, TIMEOUT_MS);

    store.dispatch('nextExperimentsRedirects');
    store.dispatch('experiments/enroll');
  });
}
